/* istanbul ignore file */
import { CommonModule } from '@angular/common';
import { Component, computed, inject, input, Signal, ChangeDetectionStrategy } from '@angular/core';
import { dateFormatPipe } from '@app/pipes/datepipe';
import { AlertComponent } from '@components/atoms/alert/alert.component';
import { MedpaceDatepickerComponent } from '@components/atoms/medpace-datepicker/medpace-datepicker.component';
import { MedpaceTextareaAutocompleteComponent } from '@components/atoms/textarea-autocomplete/medpace-textarea-autocomplete.component';
import { CardMode } from '@components/card/card.component';
import { LodgingRequestDetailsFormGroup } from '@components/request/travel-request-card/form-groups/detail-form-groups/travel/lodging-request.formgroup';
import { MedpaceAutocompleteObject } from '@models/medpaceAutocompleteObject';
import { TravelViewModelService } from '@services/travel-view-model/travel-view-model.service';
import { getUniqueObjects } from '@utility/utility';

@Component({
    selector: 'medpace-lodging-request-details',
    templateUrl: './lodging-request-details.component.html',
    styleUrls: ['./lodging-request-details.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [
        CommonModule,
        dateFormatPipe,
        AlertComponent,
        MedpaceDatepickerComponent,
        MedpaceTextareaAutocompleteComponent,
    ],
})
export class LodgingRequestDetailsComponent {
    private readonly travelViewModelService = inject(TravelViewModelService);

    public readonly mode = input.required<CardMode>();
    public readonly formGroup = input.required<LodgingRequestDetailsFormGroup>();

    public readonly autocompleteOptions: Signal<{
        specialRequests: MedpaceAutocompleteObject[];
    }> = computed(() => ({
        specialRequests: getUniqueObjects(
            this.travelViewModelService
                .travelCardViewModel()
                ?.historyData.lodging.filter((data) => data.specialRequest)
                .map((data) => ({ requestDate: data.requestDate, value: data.specialRequest })) ?? []
        ),
    }));
}
